import React, { useEffect } from "react";
import "./App.scss";
import { Outlet, useLocation } from "react-router";
import ReactGA from "react-ga4";
import * as constants from "./Utility/Constants";

function App() {
  const { pathname } = useLocation();

  ReactGA.initialize(constants.GA_TRACKING_ID);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <>
      <Outlet />
    </>
  );
}
export default App;
